"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFundraiseAPISchema = exports.CreateFundraiseWebSchema = void 0;
const moment_1 = __importDefault(require("moment"));
const yup = __importStar(require("yup"));
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const constants_1 = require("../constants");
const FUNDRAISE_NAME_REGEX = /^[-&/a-z0-9\s]+$/i;
const DATE_PAST_2_YEARS = "Date can not be more than 2 years in past";
const DATE_FUTURE_2_YEARS = "Date can not exceed 2 years in future";
const GOAL_VALUE_MAX = "Goal value can not exceed $999,999,999.99";
const CONFIRM_BANK_REQUIRED = "Confirm bank account details";
const ACCOUNT_NUMBER_MIN = "Account number should be at least 6 digits";
const ACCOUNT_NUMBER_MAX = "Account number can not exceed 12 digits";
const ACCOUNT_NAME_REQUIRED = "Please enter an account name";
const ACCOUNT_BSB_REQUIRED = "Please enter a BSB number";
const ACCOUNT_NUMBER_REQUIRED = "Please enter an account number";
const NAME_UNIQUE = "Name must be unique";
const CODE_UNIQUE = "Code must be unique";
const CreateFundraiseSchema = yup.object().shape({
    shareClassId: yup
        .string()
        .when("$fundraiseType", (fundraiseType, schema) => fundraiseType === mystake_common_sdk_1.FundraiseRoundType.SHARE
        ? schema.required("Please select a share class")
        : schema.notRequired()),
    noteId: yup
        .string()
        .when("$fundraiseType", (fundraiseType, schema) => fundraiseType === mystake_common_sdk_1.FundraiseRoundType.NOTE ? schema.required("Please select a note name") : schema.notRequired()),
    goal: yup.lazy((goal) => goal === "" || goal === undefined
        ? yup.string().required("Please enter an amount")
        : yup
            .number()
            .min(0.0, "Goal value should be at least $0.00")
            .when("$isDollar", (isDollar, schema) => isDollar ? schema.max(999999999.99, GOAL_VALUE_MAX) : schema.max(99999999999.0, GOAL_VALUE_MAX))),
    openDate: yup
        .string()
        .required(constants_1.DATE_REQUIRED)
        .test("validDate", constants_1.DATE_VALID, (openDate) => (0, moment_1.default)(openDate).isValid() && (0, mystake_common_sdk_1.getDateYear)(openDate) > 1920)
        .test("Date-in-past", DATE_PAST_2_YEARS, (openDate) => (0, moment_1.default)(new Date()).diff((0, moment_1.default)(openDate), "years", true) <= 2.001)
        .test("Date-in-future", DATE_FUTURE_2_YEARS, (openDate) => (0, moment_1.default)(openDate).diff((0, moment_1.default)(new Date()), "years", true) <= 2.001),
    tncAcceptanceDate: yup
        .string()
        .when("$isDollar", (isDollar, schema) => isDollar
        ? schema.notRequired()
        : schema.test("validDate", constants_1.DATE_VALID, (tncAcceptanceDate) => (0, moment_1.default)(tncAcceptanceDate).isValid())),
});
const fundraiseNameBaseSchema = yup
    .string()
    .trim("Please enter a name")
    .required("Please enter a name")
    .matches(FUNDRAISE_NAME_REGEX, "Name must be alphanumeric")
    .min(4, "Name should be at least 4 characters")
    .max(30);
const fundraiseCodeBaseSchema = yup
    .string()
    .required("Please enter a code")
    .matches(constants_1.ALPHANUMERIC_REGEX, "Code must be alphanumeric")
    .min(2, "Code should be at least 2 characters")
    .max(4, "Code can not exceed 4 characters");
exports.CreateFundraiseWebSchema = CreateFundraiseSchema.concat(yup.object().shape({
    name: fundraiseNameBaseSchema.when("$uniqueNames", (uniqueNames, schema) => schema.test("uniqueName", NAME_UNIQUE, (name) => !uniqueNames.find((uniqueName) => uniqueName.toLowerCase() === name[0].toLowerCase()))),
    fundraiseCode: fundraiseCodeBaseSchema.when("$uniqueCodes", (uniqueCodes, schema) => schema.test("uniqueCode", CODE_UNIQUE, (code) => !uniqueCodes.find((uniqueCode) => uniqueCode.toLowerCase() === code[0].toLowerCase()))),
    confirmBank: yup.boolean().oneOf([true], CONFIRM_BANK_REQUIRED),
}));
exports.CreateFundraiseAPISchema = CreateFundraiseSchema.concat(yup.object().shape({
    name: fundraiseNameBaseSchema,
    fundraiseCode: fundraiseCodeBaseSchema,
    customerAccountName: yup
        .string()
        .trim(ACCOUNT_NAME_REQUIRED)
        .required(ACCOUNT_NAME_REQUIRED)
        .min(2, "Account name should be at least 2 characters")
        .max(60),
    customerAccountBSB: yup
        .string()
        .required(ACCOUNT_BSB_REQUIRED)
        .trim(ACCOUNT_BSB_REQUIRED)
        .test("must be 6 digits", "BSB must be exactly 6 digits", (customerAccountBSB) => customerAccountBSB.replace(/ /g, "").length === 6)
        .matches(/^[0-9 ]+$/, "BSB should contain only digits"),
    customerAccountNumber: yup
        .string()
        .required(ACCOUNT_NUMBER_REQUIRED)
        .trim(ACCOUNT_NUMBER_REQUIRED)
        .test("minimum 6 digits", ACCOUNT_NUMBER_MIN, (customerAccountNumber) => customerAccountNumber.replace(/ /g, "").length > 5)
        .test("maximum 12 digits", ACCOUNT_NUMBER_MAX, (customerAccountNumber) => customerAccountNumber.replace(/ /g, "").length < 13)
        .matches(/^[0-9 ]+$/, "Account number should contain only digits"),
}));
//# sourceMappingURL=CreateFundraiseSchema.js.map